 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT01_COVER from '@/components/text/01_cover'
 import TEXT02_HALFTITLE from '@/components/text/02_halftitle'
 import TEXT03_SERIES from '@/components/text/03_series'
 import TEXT04_FONT1 from '@/components/text/04_font1'
 import TEXT05_FONT2 from '@/components/text/05_font2'
 import TEXT06_TITLE from '@/components/text/06_title'
 import TEXT07_COPYRIGHT from '@/components/text/07_copyright'
 import TEXT08_CONTENTS from '@/components/text/08_contents'
 import TEXT09_ILLUSTRATIONS from '@/components/text/09_illustrations'
 import TEXT10_BATTLE_HONOURS from '@/components/text/10_battle_honours'
 import TEXT11_FOREWORD from '@/components/text/11_foreword'
 import TEXT12_ACKNOWLEDGEMENTS from '@/components/text/12_acknowledgements'
 import TEXT13_INTRODUCTION from '@/components/text/13_introduction'
 import TEXT14_REGIMENT from '@/components/text/14_regiment'
 import TEXT15_CHAPTER_1 from '@/components/text/15_chapter_1'
 import TEXT16_CHAPTER_2 from '@/components/text/16_chapter_2'
 import TEXT17_CHAPTER_3 from '@/components/text/17_chapter_3'
 import TEXT18_CHAPTER_4 from '@/components/text/18_chapter_4'
 import TEXT19_CHAPTER_5 from '@/components/text/19_chapter_5'
 import TEXT20_CHAPTER_6 from '@/components/text/20_chapter_6'
 import TEXT21_CHAPTER_7 from '@/components/text/21_chapter_7'
 import TEXT22_CHAPTER_8 from '@/components/text/22_chapter_8'
 import TEXT23_CHAPTER_9 from '@/components/text/23_chapter_9'
 import TEXT24_CHAPTER_10 from '@/components/text/24_chapter_10'
 import TEXT25_CHAPTER_11 from '@/components/text/25_chapter_11'
 import TEXT26_CHAPTER_12 from '@/components/text/26_chapter_12'
 import TEXT27_CHAPTER_13 from '@/components/text/27_chapter_13'
 import TEXT28_EPILOGUE from '@/components/text/28_epilogue'
 import TEXT29_GLOSSARY from '@/components/text/29_glossary'
 import TEXT30_APP_1 from '@/components/text/30_app_1'
 import TEXT31_APP_2 from '@/components/text/31_app_2'
 import TEXT32_APP_3 from '@/components/text/32_app_3'
 import TEXT33_APP_4 from '@/components/text/33_app_4'
 import TEXT34_APP_5 from '@/components/text/34_app_5'
 import TEXT35_APP_6 from '@/components/text/35_app_6'
 import TEXT36_BIBLIOGRAPHY from '@/components/text/36_bibliography'
 import TEXT37_INDEX from '@/components/text/37_index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/08_contents",
 			"name" : "text/08_contents",
 			"component" : TEXT08_CONTENTS
 		},
 		{
 			"path" : "/text/09_illustrations",
 			"name" : "text/09_illustrations",
 			"component" : TEXT09_ILLUSTRATIONS
 		},
 		{
 			"path" : "/text/10_battle_honours",
 			"name" : "text/10_battle_honours",
 			"component" : TEXT10_BATTLE_HONOURS
 		},
 		{
 			"path" : "/text/11_foreword",
 			"name" : "text/11_foreword",
 			"component" : TEXT11_FOREWORD
 		},
 		{
 			"path" : "/text/12_acknowledgements",
 			"name" : "text/12_acknowledgements",
 			"component" : TEXT12_ACKNOWLEDGEMENTS
 		},
 		{
 			"path" : "/text/13_introduction",
 			"name" : "text/13_introduction",
 			"component" : TEXT13_INTRODUCTION
 		},
 		{
 			"path" : "/text/14_regiment",
 			"name" : "text/14_regiment",
 			"component" : TEXT14_REGIMENT
 		},
 		{
 			"path" : "/text/15_chapter_1",
 			"name" : "text/15_chapter_1",
 			"component" : TEXT15_CHAPTER_1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js